import update from 'immutability-helper';
import type { ITemplateTag } from '../templateCreate/template-types';
import { ActionTypes } from './actions';
import type { ITemplateTaggingState } from './types';

export const initialState: ITemplateTaggingState = {
  name: '',
  tagsById: {},
  saveDone: false,
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default function temnplateSharingReducer(state: ITemplateTaggingState = initialState, action: any) {
  switch (action.type) {
    case ActionTypes.RESET: {
      return action.payload || { ...initialState };
    }
    case ActionTypes.FETCH_TAGS_DONE: {
      const tagsById = {};
      action.payload.tags.forEach((tag: ITemplateTag) => {
        if (tag.tagTypeId in tagsById) {
          // @ts-expect-error -- This code was written prior to enforcing lint rules
          tagsById[tag.tagTypeId].push(tag.value);
        } else {
          // @ts-expect-error -- This code was written prior to enforcing lint rules
          tagsById[tag.tagTypeId] = [tag.value];
        }
      });
      return update(state, {
        name: { $set: action.payload.name },
        tagsById: { $set: tagsById },
      });
    }
    case ActionTypes.CHANGE_TAG: {
      return update(state, {
        tagsById: { [action.payload.tagTypeId]: { $set: action.payload.values } },
      });
    }
    case ActionTypes.CHANGE_NAME: {
      return update(state, {
        name: { $set: action.payload },
      });
    }
    case ActionTypes.SAVE_DONE: {
      return update(state, {
        saveDone: { $set: true },
      });
    }
    default: {
      return state;
    }
  }
}
